<ng-container>
  <div class="card-container" [ngClass]="{'overlay': historical}">
    <div style="text-align: center; position: relative;">
      <img [src]="campaign.Image.Uri ? campaign.Image.Uri : 'data:image/png;base64,' + 'placeholderImage'" alt="Image Missing" class="card-image">

      @if( campaign.LogoType.Uri != 'https://thuleturbo.blob.core.windows.net/t4images/ObjectType_Default_011606d6-c260-406e-92fb-82547c804b8b.png'){
      <div style="max-width: 100px; max-height: 50px; position: absolute; bottom: 15px; inset-inline-end: 15px; background: white;">
        <img [src]="campaign.LogoType?.Uri ? campaign.LogoType.Uri : '' " style="max-width: 100px; max-height: 50px;" />
      </div>
      }
    </div>
    <div style="text-align:center; padding:10px;">

      <div class="title-text">
        <h1 class="dynamicTitle" *ngIf="campaign?.Title?.trim()">
          {{ campaign.Title }}
        </h1>
      </div>

      <p *ngIf="campaign?.Comment?.trim()"
         style="color:black;display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;white-space:normal;">
        {{ campaign.Comment }}
      </p>

      @if (campaign?.PartnerOfferType === 1
      && campaign?.IsUsed === 0
      && campaign?.ValidFrom < currentTime
      && campaign?.ValidThrough > currentTime) {

      <button class="button-card" mat-raised-button color="primary" (click)="activate(campaign)">
        {{ 'Intellitrailer.MyPage.CampaignCard.btnActivate' | translate:'Activate'  }}
      </button>

      } @else if (
      (campaign?.PartnerOfferType === 2 || campaign?.PartnerOfferType === 3)
      && campaign?.IsUsed === 0
      && campaign?.ValidFrom < currentTime
      && campaign?.ValidThrough > currentTime) {

      @if (campaign?.ExternalCode && campaign.ExternalCode.trim() !== '') {
      <button class="button-card" mat-raised-button color="primary" (click)="activate(campaign)">
        {{ 'Intellitrailer.MyPage.CampaignCard.btnReadMore2' | translate:  'Read more' }}
      </button>
      }

      } @else {

      <button class="button-card" mat-raised-button color="primary" (click)="activate(campaign)">
        {{ 'Intellitrailer.MyPage.CampaignCard.btnDismiss' | translate: 'Dismiss'  }}
      </button>

      }

      <button *ngIf="campaign?.IsUsed === 0 && campaign?.ValidFrom > currentTime"
              class="button-card" mat-raised-button color="primary">
        {{ 'Intellitrailer.MyPage.CampaignCard.btnComingSoon' | translate: 'Coming Soon'  }}
      </button>

      @if (campaign?.PartnerOfferType === 1 && campaign?.IsUsed === 1) {
      <button class="button-card" mat-raised-button color="primary">
        {{ 'Intellitrailer.MyPage.CampaignCard.btnUsed' | translate: 'Used'  }}
      </button>
      } @else if (campaign?.PartnerOfferType === 2 && campaign?.IsUsed === 1) {
      <button class="button-card" mat-raised-button color="primary" (click)="activate(campaign)">
        {{ 'Intellitrailer.MyPage.CampaignCard.btnReadMore' | translate: 'Read more'  }}
      </button>
      }

      <button *ngIf="campaign?.IsUsed === 0 && campaign?.ValidThrough < currentTime"
              class="button-card" mat-raised-button color="primary">
        {{ 'Intellitrailer.MyPage.CampaignCard.btnExpired' | translate: 'Expired'  }}
      </button>

      <p *ngIf="campaign?.ValidFrom && currentTime > campaign.ValidFrom"
         style="font-size:13px;color:gray;margin:0;margin-top:10px;">
        {{ 'Intellitrailer.MyPage.CampaignCard.dateUntil' | translate: 'Valid until'  }}
        {{ campaign.ValidThrough | date:'dd-MMM' | transliterate }}
      </p>

      <p *ngIf="campaign?.ValidFrom && currentTime < campaign.ValidFrom"
         style="font-size:13px;color:gray;margin:0;margin-top:10px;">
        {{ 'Intellitrailer.MyPage.CampaignCard.dateBetween1' | translate: 'Valid between'  }}
        {{ campaign.ValidFrom | date:'dd-MMM' | transliterate }}
        {{ 'T4.CampaignCard.dateBetween2' | translate: 'and'  }}
        {{ campaign.ValidThrough | date:'dd-MMM' | transliterate }}
      </p>

      @if(campaign?.PartnerOfferType === 1){
      <p style="color:black;margin:0.3em;font-size:0.6em">
        {{ 'Intellitrailer.MyPage.CampaignCard.txtDisclamer1' | translate : 'The coupon is redeemed at ' }}
        {{ campaign?.Issuer }}
        {{ 'Intellitrailer.MyPage.CampaignCard.txtDisclamer2' |  translate : 'show the code at the checkout.'  }}
      </p>
      }
      @else if(campaign?.PartnerOfferType === 2 && campaign?.PartnerOfferDisclaimer.trim() != '' ){
      <p style="color:black;margin:0.3em;font-size:0.6em">
        {{campaign?.PartnerOfferDisclaimer}}
      </p>
      }
      @else{
      <p style="color:black;margin:0.3em;font-size:0.6em">
        {{campaign?.Issuer}}
      </p>
      }

    </div>

  </div>
</ng-container>
